import { EspecialidadeVinculosListSearchComponent } from './EspecialidadeVinculosListSearchComponent'
import { EspecialidadeVinculosListToolbar } from './EspecialidadeVinculosListToolbar'

export const EspecialidadeVinculosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <EspecialidadeVinculosListSearchComponent actions={<EspecialidadeVinculosListToolbar />} />
    </div>
  )
}
